// context/AdviserDetailsNotifications.js

const API_BASE_URL =
  process.env.REACT_APP_ROSEMOUNT_ADVISER_SERVER_URL ||
  "https://adviser-portal-members-hub.onrender.com";

const stringifyValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }

  if (value?.seconds != null) {
    return new Date(value.seconds * 1000).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  if (value instanceof Date) {
    return value.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

const formatFieldLabel = (field = "") => {
  return String(field)
    .replace(/^personalDetails\./, "")
    .replace(/^nextOfKinDetails\./, "")
    .replace(/^applicationDetails\./, "")
    .replace(/^adviserDoc\./, "")
    .replace(/([A-Z])/g, " $1")
    .replace(/\./g, " / ")
    .replace(/^./, (char) => char.toUpperCase())
    .trim();
};

export const buildCleanAdviserDetailChanges = (changes = []) => {
  return changes
    .filter(Boolean)
    .map((change) => {
      const field = change.field || change.path || "";
      const section = change.section || field.split(".")[0] || "Details";

      return {
        section,
        field,
        label: change.label || formatFieldLabel(field),
        oldValue: stringifyValue(change.oldValue ?? change.before),
        newValue: stringifyValue(change.newValue ?? change.after),
      };
    })
    .filter((change) => change.oldValue !== change.newValue);
};

export const notifyStaffAdviserDetailsUpdated = async ({
  adviserId,
  adviserName,
  adviserEmail,
  updatedBy,
  changes = [],
}) => {
  if (!API_BASE_URL) {
    throw new Error("Rosemount Adviser server URL is missing.");
  }

  const cleanChanges = buildCleanAdviserDetailChanges(changes);

  const response = await fetch(
    `${API_BASE_URL}/api/advisers/details-updated-notification`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        adviserId,
        adviserName: adviserName || "-",
        adviserEmail: adviserEmail || "-",
        updatedBy: updatedBy || "-",
        changes: cleanChanges,
      }),
    },
  );

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || "Failed to send staff notification.");
  }

  return response.json();
};
